import MuiDialog from "@mui/material/Dialog";
import MuiDialogContent, { type DialogContentProps } from "@mui/material/DialogContent";
import MuiDialogContentText, { type DialogContentTextProps } from "@mui/material/DialogContentText";
import MuiDialogTitle, { type DialogTitleProps } from "@mui/material/DialogTitle";
import { cloneElement, createContext, isValidElement, useContext, type MouseEvent, type ReactElement, type ReactNode } from "react";

interface DialogContextValue { close(): void; open(): void }
const DialogContext = createContext<DialogContextValue | null>(null);

export function Dialog({ open, onOpenChange, children, className }: { open: boolean; onOpenChange(open: boolean): void; children: ReactNode; className?: string }) {
  const value = { close: () => onOpenChange(false), open: () => onOpenChange(true) };
  return <DialogContext.Provider value={value}><MuiDialog className={className} open={open} onClose={value.close} maxWidth={false}>{children}</MuiDialog></DialogContext.Provider>;
}

function DialogAction({ children, action }: { children: ReactNode; action: "close" | "open" }) {
  const context = useContext(DialogContext);
  if (!context || !isValidElement(children)) return children;
  const child = children as ReactElement<{ onClick?: (event: MouseEvent<HTMLElement>) => void }>;
  return cloneElement(child, { onClick: (event) => { child.props.onClick?.(event); if (!event.defaultPrevented) context[action](); } });
}

export function DialogTrigger({ children }: { asChild?: boolean; children: ReactNode }) { return <DialogAction action="open">{children}</DialogAction>; }
export function DialogClose({ children }: { asChild?: boolean; children: ReactNode }) { return <DialogAction action="close">{children}</DialogAction>; }
export function DialogContent({ className, ...props }: DialogContentProps) { return <MuiDialogContent className={className} {...props} />; }
export function DialogTitle(props: DialogTitleProps) { return <MuiDialogTitle {...props} />; }
export function DialogDescription(props: DialogContentTextProps) { return <MuiDialogContentText {...props} />; }
